import useMoveableLabel from "components/Pages/Home/UploadForms/useMoveableLabel.js";
import { Editor } from "react-draft-wysiwyg";
import {
  ContentState,
  EditorState,
  convertToRaw,
  convertFromHTML,
} from "draft-js";
import draftToHtml from "draftjs-to-html";
import { useEffect, useRef, useState } from "react";
import { useContent } from "contexts/contentContext/contentContext.js";
import { useCustomController } from "./useCustomController.js";

import "components/Reusable/Form/Form.scss";

const toolbarOptions = {
  options: ["inline", "list", "textAlign"],
  inline: {
    inDropdown: false,
    options: ["bold", "italic", "underline"],
  },
  list: {
    inDropdown: false,
    options: ["unordered", "ordered"],
  },
};

const containsOnlyHTMLTags = (inputString = "") => {
  if (!inputString) {
    return false;
  }

  // Remove all HTML tags from the input string
  const stringWithoutTags = inputString.replace(/<[^>]*>/g, "");

  // Check if the resulting string is empty (contains only tags)
  return stringWithoutTags.trim() === "";
};

const RichTextEditorField = (props) => {
  const { fieldControls, hasError } = useCustomController(props);
  // editor state is an object for Editor component
  const [editorState, setEditorState] = useState(null);
  // value is the string for storage
  const [value, setValue] = useState(fieldControls.value);

  // getting existing value from fieldControls.value and setting it to editorState
  useEffect(() => {
    if (fieldControls.value) {
      const blocksFromHTML = convertFromHTML(fieldControls.value);
      const contentState = ContentState.createFromBlockArray(blocksFromHTML);
      const initialEditorState = EditorState.createWithContent(contentState);
      setEditorState(initialEditorState);
    }
  }, []);

  const { getTextByKey, getDirection } = useContent();
  const [direction, setDirection] = useState(getDirection());

  const [focused, setFocused] = useState(props.alwaysShowTools);

  const handleBlur = () => {
    if (!props.alwaysShowTools) setFocused(false);
  };

  // on value change set it to form state
  useEffect(() => {
    if (containsOnlyHTMLTags(value) && value.length > 0) {
      setValue("");
    } else {
      fieldControls.onChange(value);
      if (props.setBodyValue) props.setBodyValue(props, value);
    }
  }, [value]);

  // handeling the change of editor state
  const handleChange = (editorState) => {
    const contentState = editorState.getCurrentContent();
    const rawContent = convertToRaw(contentState);
    const htmlContent = draftToHtml(rawContent);
    setEditorState(editorState);
    setValue(htmlContent);
  };

  const { labelClassName } = useMoveableLabel({
    label: props.item.label,
    value: value?.length > 0 ? value : false,
  });

  const inputRef = useRef(null);

  return (
    <div
      tabIndex={0}
      disable={true}
      className={`rich-text-editor label-div${
        hasError ? " invalid-input" : ""
      }${focused ? " rich-focused" : ""}`}
      ref={inputRef}
    >
      <div className={`${labelClassName || "input-label"}`}>
        {getTextByKey("share-mail-message")}
      </div>
      <Editor
        editorState={editorState}
        toolbar={toolbarOptions}
        // toolbarOnFocus={!props.alwaysShowTools}
        wrapperClassName="editor-wrapper"
        editorClassName={`textarea-field${!value ? " empty" : ""} ${direction}`}
        toolbarClassName="tollbar-container"
        onEditorStateChange={handleChange}
        onFocus={() => {
          setFocused(true);
        }}
        onBlur={() => {
          handleBlur();
        }}
        onTab={() => {
          return true;
        }}
      />
    </div>
  );
};

export default RichTextEditorField;
